import { Injectable } from '@angular/core';
import * as signalR from '@microsoft/signalr';
import { environment } from 'src/environments/environment';
import { AuthenticationService } from './authentication.service';

@Injectable({
  providedIn: 'root'
})
export class SignalRService {
  private hubConnection!: signalR.HubConnection;

  constructor(private authService: AuthenticationService) { }

  public startConnection = () => {
    this.hubConnection = new signalR.HubConnectionBuilder()
    .withUrl(environment.signalR, {
      accessTokenFactory: () => this.authService.currentUserValue!.token,
      transport: signalR.HttpTransportType.WebSockets || signalR.HttpTransportType.LongPolling
    })
    .build();

  this.hubConnection
    .start()
    .then(() => console.log('Connection started ...'))
    .catch((err: any) => console.log('Error while starting connection ... ' + err));

  }
  stopConnection() {
    if (this.hubConnection) {
      this.hubConnection
        .stop()
        .then(() => console.log('Connection stopped ...'))
        .catch((err: any) => console.log('Error while stopping connection ... ' + err));
    }
  }

  // changeNotificationCount = (context: any, handleFunc: any) => {
  //   this.hubConnection?.on('changeNotificationCount', (count: any) => {
  //     handleFunc(context, count);
  //   });
  // }
  LogOut = (context: any, handleFunc: any) => {
    this.hubConnection?.on('LogOut', (count: any) => {
      handleFunc(context, count);
    });
  }
  UserRoleCount = (context: any, handleFunc: any) => {
    this.hubConnection?.on('UserRoleCount', (count: number, id: string) => {
      handleFunc(context, count, id);
    });
  }
  IngredientCountInCatigory = (context: any, handleFunc: any) => {
    this.hubConnection?.on('IngredientCountInCatigory', (count: any) => {
      handleFunc(context, count);
    });
  }
}
